import React, { FunctionComponent } from 'react';
import { ProBadgeSvg } from '../../svg/general.component';
import { ArrowDownIcon, PersonIcon } from '../../svg/icons.component';
import { accountToggleProBadge } from './account-dropdown-toggle.css';

export type AccountDropdownToggleProps = {
	firstName?: string;
	isPro?: boolean;
	isOpen?: boolean;
};

export const AccountDropdownToggle: FunctionComponent<AccountDropdownToggleProps> = ({ firstName, isPro = false, isOpen = false }) => {
	const theme = isOpen ? 'theme-primary' : 'theme-secondary';

	return (
		<div className={`hover-theme-primary ${theme} flex items-center pointer`} data-tracking="nav:menu:My Account">
			{!isPro && <PersonIcon className="f1" />}
			<div className="flex-column ml2">
				<span className="f6">
					{firstName ? (
						<>
							Hello, <div className="f6 dib">{firstName}</div>
						</>
					) : (
						<>Log In</>
					)}
				</span>
				<div className="f5 flex flex-row items-center">
					{isPro && <ProBadgeSvg className={`${accountToggleProBadge} pr1 pt1 theme-accent`} />}
					{firstName ? <>My Account</> : <>Orders & Returns</>}
					<ArrowDownIcon className="v-mid" />
				</div>
			</div>
		</div>
	);
};
